import './sidebar.scss'
import CleanoutItemProps from '../../props/CleanoutItems'
import { config } from '../../config'
import { Filters } from 'nsw-design-system'
import {
  FormEvent,
  FormEventHandler,
  MouseEventHandler,
  useEffect,
  useState,
} from 'react'
import LocationProps from '../../props/LocationProps'

type filterListProps = {
  selectedCategories: string[]
  selectedCollectables: string[]
  setSelectedCategories: (cat1: (cats: string[]) => string[]) => void
  setSelectedCollectables: (cat1: (cats: string[]) => string[]) => void
  filterLists: CleanoutItemProps[]
  filtersApplied: boolean
  setFiltersApplied: (flag: boolean) => void
  locations: LocationProps[]
}

const Filter = ({
  filterLists,
  setSelectedCategories,
  setSelectedCollectables,
  setFiltersApplied,
  filtersApplied,
  // locations
}: filterListProps) => {
  const [hiddenFilterCount, setHiddenFilterCount] = useState<number>(0)
  const [hiddenItemsCount, setHiddenItemsCount] = useState<number>(0)
  const [localAppliedCategories, setLocalAppliedCategories ] = useState<string[]>([])
  const [localAppliedCollectables, setLocalAppliedCollectables ] = useState<string[]>([])
  const [filtersExpanded, setFiltersExpanded] = useState<boolean>(false)

  const handleFilterChange = (
    state: string[],
    val: string,
    checked: boolean,
  ) => {
    if (state.includes(val) && !checked) {
      // if it was on and we turned it off we remove it from the list.
      const idx = state.indexOf(val)
      if (idx > -1) state.splice(idx, 1)
    } else if (!state.includes(val) && checked) {
      // if it was not already in there and we turned it on we need to add it
      state.push(val)
    }

    return state
  }

  useEffect(() => {
    const filters = document.querySelectorAll('.js-filters')
    if (!filters) return
    filters.forEach((element) => {
      new Filters(element).init()
    })

  }, [])

  const handleCategoryChange: FormEventHandler = (
    evt: FormEvent<HTMLInputElement>,
  ) => {
    const target = evt.target as HTMLInputElement
    if (!target || target.nodeName !== 'INPUT') return
    const val: string = target.value
    const checked: boolean = target.checked

    // we reset this every time a change is made so we only act when it equals true, when the apply button is hit.
    // setFiltersApplied(false)
    setLocalAppliedCategories((prevState: string[]) => {
      return [...handleFilterChange(prevState, val, checked)]
    })
    setFiltersApplied(false)
  }

  const handleCollectableChange: FormEventHandler = (
    evt: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const target = evt.target as HTMLInputElement
    if (!target || target.nodeName !== 'INPUT') return
    const val = target.value
    const checked = target.checked
    // we reset this every time a change is made so we only act when it equals true, when the apply button is hit.
    setFiltersApplied(false)

    setLocalAppliedCollectables(prevState => {
      return [...handleFilterChange(prevState, val, checked)]
    })
    setFiltersApplied(false)
  }

  const handleApplyFilters:MouseEventHandler = (evt) => {
    evt.preventDefault()
    setSelectedCategories(() => [...localAppliedCategories])
    setSelectedCollectables(() => [...localAppliedCollectables])
    setFiltersApplied(true)
    // Keep filters expanded state when applying
    const filtersList = document.querySelector('.crc-form__fieldset')
    if (filtersExpanded && filtersList) {
      filtersList.classList.add('active')
    }
    scrollToView()
  }

  const scrollToView = () => {
    const el = document.getElementById('crc-switch')
    if (!el) return
    el.scrollIntoView({behavior: 'auto'})
  }

  const handleResetFilters: MouseEventHandler = (evt) => {
    evt.preventDefault()
    setLocalAppliedCategories(() => [])
    setLocalAppliedCollectables(() => [])
    setSelectedCategories(() => [])
    setSelectedCollectables(() => [])
    setFiltersApplied(true)
    setFiltersExpanded(false)
    const filtersList = document.querySelector('.crc-form__fieldset')
    if (filtersList) {
      filtersList.classList.remove('active')
    }
    setHiddenItemsCount(() => filterLists.length - config.filters.itemsToShow)
    scrollToView()
  }

  useEffect(() => {
    setHiddenFilterCount(() => filterLists.length - config.filters.itemsToShow)
    setHiddenItemsCount(() => filterLists.length - config.filters.itemsToShow)
  }, [filterLists])

  const calculateHiddenItems = (prev: HTMLElement, val: number) => {
    return prev?.classList.contains('active')
    ? val
    : filterLists.length - config.filters.itemsToShow
  }

  const showMoreFilters: MouseEventHandler = evt => {
    const target = evt.target as HTMLElement
    if (!target) return
    const prev = target.previousElementSibling as HTMLElement
    prev?.classList.toggle('active')
    setFiltersExpanded(!filtersExpanded)
    setHiddenItemsCount(() => calculateHiddenItems(prev, 0))
  }

  return (
    <div className="nsw-filters crc-filters  nsw-filters--down js-filters nsw-m-bottom-md-xs nsw-m-bottom-md ">
      <div className="nsw-filters__controls js-filters__count">
        <button>
          <span className="material-icons nsw-material-icons" aria-hidden="true">tune</span>
          <span>Filters</span>
          <span className="material-icons nsw-material-icons" aria-hidden="true">keyboard_arrow_down</span>
        </button>
      </div>

      <div className="nsw-filters__wrapper">
        <div className="nsw-filters__title crc-filters__title" id={`${config.namespace}-sidebartitle`}>Filter Results</div>

        <form
          // onReset={handleResetFilters}
          // onSubmit={handleApplyFilters}
          className="nsw-filters__list"
        >
          <div className="nsw-filters__item">
            <div className="nsw-filters__item-content">
              <fieldset className="nsw-form__fieldset">
                <legend className="nsw-form__legend">Category</legend>
                <input
                  className="nsw-form__checkbox-input"
                  type="checkbox"
                  name="filters-category"
                  value="crc"
                  id="filters-category-crc"
                  onChange={handleCategoryChange}
                />
                <label
                  className="nsw-form__checkbox-label"
                  htmlFor="filters-category-crc"
                >
                  {config.titleMap.crc}
                </label>

                <input
                  className="nsw-form__checkbox-input"
                  type="checkbox"
                  name="filters-category"
                  value="cre"
                  id="filters-category-cre"
                  onChange={handleCategoryChange}
                />
                <label
                  className="nsw-form__checkbox-label"
                  htmlFor="filters-category-cre"
                >
                  {config.titleMap.cre}
                </label>
              </fieldset>
            </div>
          </div>

          {filterLists?.length && (
            <div className="nsw-filters__list">
              <div className="nsw-filters__item">
                <div className="nsw-filters__item-content">
                  <fieldset className="nsw-form__fieldset crc-form__fieldset">
                    <legend className="nsw-form__legend">
                      Accepted Materials
                    </legend>
                    {filterLists.map((item, idx) => {
                      return (
                        <>
                          <input
                            className={`nsw-form__checkbox-input ${
                              filtersExpanded || idx < filterLists.length - hiddenItemsCount ? '' : 'nsw-display-none'
                            }`}
                            type="checkbox"
                            name="filters-accepted"
                            value={item.id}
                            id={`filters-accepted-${item.id}`}
                            onChange={handleCollectableChange}
                          />
                          <label
                            className={`nsw-form__checkbox-label ${
                              filtersExpanded || idx < filterLists.length - hiddenItemsCount ? '' : 'nsw-display-none'
                            }`}
                            htmlFor={`filters-accepted-${item.id}`}
                          >
                            {item.title}
                          </label>
                        </>
                      )
                    })}
                  </fieldset>
                  <button
                    type="button"
                    onClick={showMoreFilters}
                    className="nsw-display-block nsw-m-top-sm  crc-form__button"
                  >
                    {!filtersExpanded && <>Show all accepted materials ({hiddenFilterCount})</>}
                    {filtersExpanded && <>Hide {hiddenFilterCount} accepted materials</>}
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="nsw-filters__accept">
            <button
              type="submit"
              onClick={handleApplyFilters}
              className="nsw-button nsw-button--dark nsw-button--full-width"
              disabled={filtersApplied}
            >
              Apply filters
            </button>
          </div>
          <div className="nsw-filters__cancel">
            <button onClick={handleResetFilters} type="reset">Clear all filters</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Filter
